import React, { useState, useEffect, useCallback } from "react";
import { Table, OverlayTrigger, Tooltip } from "react-bootstrap";
import { MdDelete } from "react-icons/md";
import { toast } from "react-toastify";
import FileDownloader from "../../../components/UI/Button/FileDownloader";
import EfisModal from "../../../components/UI/EfisModal/EfisModal";
import FormAlert from "../../../components/UI/FormAlert/FormAlert";
import useApiClient, { apiRoutes } from "../../../hooks/apiClient";
import DateTime from "../../../components/Formatters/DateTime";

const AnexosSpf = ({ anexos, sqAberturaProcesso, permissao }) => {
  const setPageNumber = useState(1)[1];
  const [showAlerta, setShowAlerta] = useState(false);
  const [showExcluirConfirm, setShowExcluirConfirm] = useState({
    show: false,
    body: null,
    context: null,
  });

  const {
    request: deleteItemRequest,
    isLoading: deleteItemIsLoading,
    data: deleteItemData,
    errors: deleteItemErrors,
  } = useApiClient();

  const handlePageChange = useCallback(
    (newPageNumber) => {
      setPageNumber(newPageNumber);
      window.location.reload();
    },
    [setPageNumber],
  );

  const refreshItems = useCallback(() => {
    handlePageChange();
  }, [handlePageChange]);

  useEffect(() => {
    if (!deleteItemData && !deleteItemErrors) return;

    if (deleteItemData) {
      toast.success("Item excluído com sucesso.");
      refreshItems();
    }

    if (deleteItemErrors) {
      setShowAlerta(true);
    }

    setShowExcluirConfirm({ show: false });
  }, [deleteItemData, deleteItemErrors, refreshItems, setShowExcluirConfirm]);

  return (
    <>
      <EfisModal
        show={showExcluirConfirm.show}
        body={showExcluirConfirm.body}
        loadingConfirmationAction={deleteItemIsLoading}
        closeHandler={() => setShowExcluirConfirm({ show: false })}
        confirmationHandler={() =>
          deleteItemRequest(apiRoutes.fiscalizacao.procedimentoFiscal.excluirAnexo, {
            sequencialAberturaProcesso: sqAberturaProcesso,
            sequencialItem: showExcluirConfirm.context,
          })
        }
      />
      <FormAlert
        show={showAlerta}
        errors={deleteItemErrors}
        isLoading={deleteItemIsLoading}
        closeHandler={() => setShowAlerta(false)}
      />

      {anexos.length > 0 ? (
        <Table striped bordered hover>
          <thead>
            <tr>
              <th>Nome Arquivo</th>
              <th>Data Inclusão</th>
              <th>Ações</th>
            </tr>
          </thead>
          <tbody>
            {anexos.length > 0 &&
              anexos.map((anexo) => (
                <tr>
                  <td>{anexo.nomeArquivo}</td>
                  <td>
                    <DateTime value={anexo.dtInclusao ?? anexo.dtUpload} stringFormat="dd/MM/yyyy HH:mm" />
                  </td>
                  <td>
                    {permissao ? (
                      <OverlayTrigger placement="top" overlay={<Tooltip>{`Excluir ${anexo.nomeArquivo}?`}</Tooltip>}>
                        <MdDelete
                          onClick={() =>
                            setShowExcluirConfirm({
                              show: true,
                              body: `Deseja realmente excluir arquivo: ${anexo.nomeArquivo}?`,
                              context: anexo.sequencialItem,
                            })
                          }
                          className="btn-lg text-danger pa-0 p-0 btn btn-bg-transparent"
                          title="Excluir"
                        />
                      </OverlayTrigger>
                    ) : null}

                    <FileDownloader
                      binario={anexo.arquivo}
                      tooltip={anexo.nomeArquivo}
                      nomeArquivo={anexo.nomeArquivo}
                      className="ml-3"
                    />
                  </td>
                </tr>
              ))}
          </tbody>
        </Table>
      ) : null}
    </>
  );
};

export default AnexosSpf;
